import { useStore } from '@/utils/vue-api';
import { screenShot } from '@/view/enterprise_rebuild/hooks/screenShot';
import eventBus from '@rebuild/utils/event-bus';

export const useIframeMessage = () => {
	const store = useStore();

	const handlePreviewMessage = e => {
		const msgData = e.data || {};
		const { fromHost, config = {} } = msgData;
		if (fromHost) {
			const hostConfig = {
				fromHost
			};
			if (config.hideList) {
				hostConfig.hideList = config.hideList;
			}
			if (config.entryUrl) {
				hostConfig.entryUrl = config.entryUrl;
			}
			store.commit('setHostConfig', hostConfig);
		}
		if (e?.data?.screenshot) screenShot({ token: e.data.token });
		// 派发事件
		eventBus.emit('iframe-message', msgData);
	};

	const addIframeMessageListener = () => {
		window.addEventListener('message', handlePreviewMessage);
	};

	const removeIframeMessageListener = () => {
		window.removeEventListener('message', handlePreviewMessage);
		// 事件清理
		eventBus.clear('iframe-message');
	};

	return {
		addIframeMessageListener,
		removeIframeMessageListener
	};
};
